import { render, staticRenderFns } from "./CopyRoute.vue?vue&type=template&id=018c8452&"
import script from "./CopyRoute.vue?vue&type=script&lang=js&"
export * from "./CopyRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports